import { Meteor } from 'meteor/meteor';
import { check } from 'meteor/check';
import AnnotationTemplates from '../AnnotationTemplates';

Meteor.publish('annotationTemplates', () => AnnotationTemplates.find({}));

// Note: annotationTemplates.view is also used when editing an existing annotationTemplate.
Meteor.publish('annotationTemplates.view', annotationTemplateId => {
  check(annotationTemplateId, String);
  return AnnotationTemplates.find({ _id: annotationTemplateId });
});

Meteor.publish('annotationTemplates.usersView', () =>
  AnnotationTemplates.find({}, { fields: { owner: 0 } })
);

Meteor.publish('annotationTemplatesCustom.manyVideos', manytemplatesId => {
  check(manytemplatesId, [String]);
  return AnnotationTemplates.find({ _id: { $in: manytemplatesId } }, { fields: { owner: 0 } });
});
